// Wave 5: "Join the waitlist" on the landing page: one email field posting to POST /api/waitlist (api signup.ts
// joinWaitlist; one row per email, a repeat is fine). Admins invite people from it in waves (Admin > Invites >
// Waitlist); nothing is emailed from here.
import { useState, type FormEvent } from "react";
import { authApi } from "../auth/authApi";
import { looksLikeEmail } from "./waitlist-email";

export function Waitlist({ where }: { where: string }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "busy" | "done">("idle");
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!looksLikeEmail(email)) return setError("That doesn't look like an email address.");
    setError(null);
    setState("busy");
    try {
      await authApi.joinWaitlist(email);
      setState("done");
    } catch (err) {
      setState("idle");
      setError((err as Error).message || "Couldn't add you just now. Try again.");
    }
  };
  if (state === "done")
    return (
      <p className="lp-waitlist-done" role="status" data-where={where}>
        You're on the list. We'll send an invite to {email.trim()} when there's room.
      </p>
    );
  return (
    <form className="lp-waitlist" onSubmit={submit} data-where={where} noValidate>
      <label className="lp-waitlist-label" htmlFor={`lp-wl-${where}`}>
        No invite yet? Join the waitlist.
      </label>
      <div className="lp-waitlist-row">
        <input id={`lp-wl-${where}`} type="email" inputMode="email" autoComplete="email" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} aria-invalid={!!error} aria-describedby={error ? `lp-wl-err-${where}` : undefined} />
        <button type="submit" className="lp-btn lp-btn-ghost" disabled={state === "busy"}>
          {state === "busy" ? "Adding you" : "Join the waitlist"}
        </button>
      </div>
      {error && (
        <p id={`lp-wl-err-${where}`} className="lp-waitlist-error" role="alert">
          {error}
        </p>
      )}
    </form>
  );
}
